import { render } from "./DualloAdminView.vue?vue&type=template&id=75eedda0&scoped=true"
import script from "./DualloAdminView.vue?vue&type=script&lang=js"
export * from "./DualloAdminView.vue?vue&type=script&lang=js"

import "./DualloAdminView.vue?vue&type=style&index=0&id=75eedda0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75eedda0"]])

export default __exports__